module.exports = __webpack_public_path__ + "img/default1.1ec50d81.png";